import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { SnapshotOverrideView } from "./SnapshotOverrideView";
import { SnapshotOverrideViewStore } from "../../store/SnapshotOverrideViewStore";
import { useStore } from "../../../../hooks";

export const SnapshotOverrideViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/snapshotOverride/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new SnapshotOverrideViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <SnapshotOverrideView snapshotOverrideViewStore={store} />
      </PageLayout>
    </div>
  );
});
